import poster1 from "../assets/job-illustrations/Back-End-Illustration.svg";
import poster2 from "../assets/job-illustrations/Front-End-Illustration.svg";
import poster3 from "../assets/job-illustrations/IT-Admin-Illustration.svg";
import poster4 from "../assets/job-illustrations/IT-Helpdesk-Illustration.svg";
import poster5 from "../assets/job-illustrations/Mobile-Developer.svg";
import poster6 from "../assets/job-illustrations/Software-Quality-Assurance-Illustration.svg";
import poster7 from "../assets/job-illustrations/System-Analys-Illustration.svg";
import poster8 from "../assets/job-illustrations/UX-Illustration.svg";

const data = [
  { poster: poster7, position: "System Analyst" },
  { poster: poster2, position: "Front End" },
  { poster: poster1, position: "Back End" },
  { poster: poster5, position: "Android & iOS Developer" },
  { poster: poster8, position: "UI/UX" },
  { poster: poster3, position: "IT Admin" },
  { poster: poster6, position: "Software Quality Assurance" },
  { poster: poster4, position: "IT Helpdesk" },
];

export default data;
